import { LineKinds, Color, LineStyle, PaintStyle } from "../../drawing";
import { ILineDrawable } from "./ILineDrawable";
import { AbstractCheckableItem, CheckableItemValueSource } from "./AbstractCheckableItem";
import { IPaintableOnEditing } from "./IPaintableOnEditing";
import { TypeKeys } from "./TypeKeys";
import { INameGroupEmptyValidatable } from "./INameGroupEmptyValidatable";
import { IHisInformationSelectable } from "./IHisInformationSelectable";
import { IFreeInputable } from "./IFreeInputable";

export class CircleSelectItem extends AbstractCheckableItem implements
  IFreeInputable,
  IHisInformationSelectable,
  ILineDrawable,
  IPaintableOnEditing,
  INameGroupEmptyValidatable {
  constructor(isChecked: boolean, checkedValue: number, uncheckedValue: number) {
    super(TypeKeys.CircleSelectItem, new CheckableItemValueSource(isChecked, checkedValue, uncheckedValue));
  }

  public lineStyle: LineStyle = new LineStyle(new Color("#000000"), LineKinds.Normal, 2);
  public paintStyleOnEditing: PaintStyle = null;
  public paintStyle: PaintStyle = null;
 
  protected createCloneInstance(): CircleSelectItem {
    return new CircleSelectItem(
      this.originalValueSource.isChecked,
      this.originalValueSource.checkedValue,
      this.originalValueSource.uncheckedValue);
  }

  protected applyMembers(clone: CircleSelectItem): void {
    super.applyMembers(clone);
    clone.lineStyle = this.cloneValue(this.lineStyle);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
  }
  
  /** 選択画面から入力可能か */
  get isInputableFromScreen(): boolean {
    if (this.isHisInfo && this.hisItemParameter != null) { // HIS情報選択ダイアログ
      return this.hisItemParameter.isRequireSelectDialog;
    }
    return false;
  }

  get currentNaturalText(): string {
      return this.isChecked
        ? (this.isNaturalViewEnable && this.naturalText)
          ? this.naturalText
          : this.itemName
        : "";
  }
}
